// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import { editPosition, getPositions, getPosition } from '@store/HR/HRSetting/positionSlice';
import { formPosition } from '../../../ValidationForm/validationSchema';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Loading from '@components/Shared/Loader/Loading';

// function EditPosition({ id }) {
//   const { HasPermission } = usePermissions();

//   const { t, i18n } = useTranslation();

//   const dispatch = useDispatch();

//   const { Organizations } = useGetOrganizations();
//   const { Jobs } = useSelector(state => state.Jobs);
//   const { Locations } = useSelector(state => state.Locations);

//   const { loading, error, Position } = useSelector(state => state.Positions);

//   useEffect(() => {
//     if (!Position?.length) {
//       dispatch(getPosition(id));
//     }
//   }, [dispatch, id]);

//   console.log(Position);

//   const formik = useFormik({
//     initialValues: {
//       jobId: Position ? Position.jobId : '',
//       organizationId: Position ? Position.organizationId : '',
//       locationId: Position ? Position.locationId : '',
//       name: Position ? Position.name : '',
//       name2: Position ? Position.name2 : '',
//       headcount: Position ? Position.headcount : '',
//       comments: Position ? Position.comments : ''
//     },
//     enableReinitialize: true,
//     validationSchema: formPosition(t),

//     onSubmit: (values, { resetForm }) => {
//       dispatch(
//         editPosition({
//           id: Position.id,
//           jobId: values.jobId,
//           organizationId: values.organizationId,
//           locationId: values.locationId,
//           name: values.name,
//           name2: values.name2,
//           headcount: values.headcount,

//           comments: values.comments
//         })
//       )
//         .unwrap()
//         .then(() => {
//           CustomAlert({ action: 'Add' });
//           dispatch(getPositions());
//           // Navigate(-1, { replace: true });
//         })
//         .catch(error => {
//           // alert(error);
//           CustomAlert({ action: 'Error', msg: error });
//         })
//         .finally(() => formik.setSubmitting(false));
//     }
//   });

//   return (
//     <>
//       <Loading loading={loading} error={error}>
//         <Form onSubmit={formik.handleSubmit}>
//           <div className='row'>
//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('LocalName')}</label>
//                 <Form.Control
//                   className='form-control'
//                   type='text'
//                   autoComplete='off'
//                   name='name2'
//                   onChange={formik.handleChange}
//                   value={formik.values.name2 || ' '}
//                   isInvalid={!!formik.errors.name2}
//                 />
//                 <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
//               </div>
//             </div>

//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('GlobalName')}</label>
//                 <Form.Control
//                   className='form-control'
//                   type='text'
//                   autoComplete='off'
//                   name='name'
//                   onChange={formik.handleChange}
//                   value={formik.values.name || ' '}
//                   isInvalid={!!formik.errors.name}
//                 />
//                 <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
//               </div>
//             </div>
//           </div>
//           <div className='row'>
//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('Organization')}</label>
//                 <Form.Select
//                   className='form-select'
//                   name='organizationId'
//                   onChange={formik.handleChange}
//                   value={formik.values.organizationId || ' '}
//                   isInvalid={!!formik.errors.organizationId}
//                 >
//                   <option value={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                   {Organizations?.map(item => (
//                     <option key={item.id} value={item.id}>
//                       {i18n.language === 'ar' ? item.name2 : item.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//                 <Form.Control.Feedback type='invalid'>{formik.errors.organizationId}</Form.Control.Feedback>
//               </div>
//             </div>

//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('Job')}</label>
//                 <Form.Select
//                   className='form-select'
//                   name='jobId'
//                   onChange={formik.handleChange}
//                   value={formik.values.jobId || ' '}
//                   isInvalid={!!formik.errors.jobId}
//                 >
//                   <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                   {Jobs?.map(item => (
//                     <option key={item.id} value={item.id}>
//                       {i18n.language === 'en' ? item.name2 : item.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//                 <Form.Control.Feedback type='invalid'>{formik.errors.jobId}</Form.Control.Feedback>
//               </div>
//             </div>
//           </div>

//           <div className='row'>
//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('location')}</label>
//                 <Form.Select
//                   className='form-select'
//                   name='locationId'
//                   onChange={formik.handleChange}
//                   value={formik.values.locationId || ' '}
//                   isInvalid={!!formik.errors.locationId}
//                 >
//                   <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

//                   {Locations?.map(item => (
//                     <option key={item.id} value={item.id}>
//                       {i18n.language === 'ar' ? item.name2 : item.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//                 <Form.Control.Feedback type='invalid'>{formik.errors.locationId}</Form.Control.Feedback>
//               </div>
//             </div>

//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('Vacancy')}</label>
//                 <Form.Control
//                   className='form-control'
//                   type='text'
//                   autoComplete='off'
//                   name='headcount'
//                   onChange={formik.handleChange}
//                   value={formik.values.headcount}
//                   isInvalid={!!formik.errors.headcount}
//                 />
//                 <Form.Control.Feedback type='invalid'>{formik.errors.headcount}</Form.Control.Feedback>
//               </div>
//             </div>

//             <div className='col-xl-12'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('Note')}</label>
//                 <Form.Control
//                   className='form-control'
//                   as='textarea'
//                   rows={3}
//                   name='comments'
//                   onChange={formik.handleChange}
//                   value={formik.values.comments || ' '}
//                   isInvalid={!!formik.errors.comments}
//                 />

//                 <div></div>
//               </div>
//             </div>
//           </div>

//           <div className='text-center'>
//             <div className='d-flex justify-content-between gap-2'>
//               {HasPermission('EditHrPerPosition') && (
//                 <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100'>
//                   {formik.isSubmitting ? (
//                     <div className='spinner-border spinner-border-sm me-2'></div>
//                   ) : (
//                     <i className='fas fa-save fa-lg fa-fw me-2'></i>
//                   )}
//                   {t('Save')}
//                 </button>
//               )}
//               <button
//                 type='button'
//                 className='btn btn-lg  btn-default mb-1 w-100'
//                 data-bs-dismiss='modal'
//                 id='closeModalJob'
//               >
//                 <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//               </button>
//             </div>
//           </div>
//         </Form>
//       </Loading>
//     </>
//   );
// }

function EditPosition({ id }) {
  const { HasPermission } = usePermissions();

  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();

  const { Organizations } = useGetOrganizations();
  const { Jobs } = useSelector(state => state.Jobs);
  const { Locations } = useSelector(state => state.Locations);

  const { loading, error, Position } = useSelector(state => state.Positions);

  useEffect(() => {
    if (!Position?.length) {
      dispatch(getPosition(id));
    }
  }, [dispatch, id]);

  console.log(Position);

  const formik = useFormik({
    initialValues: {
      jobId: Position ? Position.jobId : '',
      organizationId: Position ? Position.organizationId : '',
      locationId: Position ? Position.locationId : '',
      name: Position ? Position.name : '',
      name2: Position ? Position.name2 : '',
      code: Position ? Position.code : '', // Added
      headcount: Position ? Position.headcount : '',
      comments: Position ? Position.comments : ''
    },
    enableReinitialize: true,
    validationSchema: formPosition(t),

    onSubmit: (values, { resetForm }) => {
      dispatch(
        editPosition({
          id: Position.id,
          jobId: values.jobId,
          organizationId: values.organizationId,
          locationId: values.locationId,
          name: values.name,
          name2: values.name2,
          code: values.code, // Added
          headcount: values.headcount,
          comments: values.comments
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Add' });
          dispatch(getPositions());
          // Navigate(-1, { replace: true });
        })
        .catch(error => {
          // alert(error);
          CustomAlert({ action: 'Error', msg: error });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  return (
    <>
      <Loading loading={loading} error={error}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='row'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('LocalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name2'
                  onChange={formik.handleChange}
                  value={formik.values.name2 || ' '}
                  isInvalid={!!formik.errors.name2}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('GlobalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name'
                  onChange={formik.handleChange}
                  value={formik.values.name || ' '}
                  isInvalid={!!formik.errors.name}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
              </div>
            </div>
          </div>

          {/* Added Code Field */}
          <div className='row'>
            <div className='col-xl-12'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Code')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='code'
                  onChange={formik.handleChange}
                  value={formik.values.code || ' '}
                  isInvalid={!!formik.errors.code}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.code}</Form.Control.Feedback>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Organization')}</label>
                <Form.Select
                  className='form-select'
                  name='organizationId'
                  onChange={formik.handleChange}
                  value={formik.values.organizationId || ' '}
                  isInvalid={!!formik.errors.organizationId}
                >
                  <option value={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {Organizations?.map(item => (
                    <option key={item.id} value={item.id}>
                      {i18n.language === 'ar' ? item.name2 : item.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type='invalid'>{formik.errors.organizationId}</Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Job')}</label>
                <Form.Select
                  className='form-select'
                  name='jobId'
                  onChange={formik.handleChange}
                  value={formik.values.jobId || ' '}
                  isInvalid={!!formik.errors.jobId}
                >
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {Jobs?.map(item => (
                    <option key={item.id} value={item.id}>
                      {i18n.language === 'en' ? item.name2 : item.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type='invalid'>{formik.errors.jobId}</Form.Control.Feedback>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('location')}</label>
                <Form.Select
                  className='form-select'
                  name='locationId'
                  onChange={formik.handleChange}
                  value={formik.values.locationId || ' '}
                  isInvalid={!!formik.errors.locationId}
                >
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

                  {Locations?.map(item => (
                    <option key={item.id} value={item.id}>
                      {i18n.language === 'ar' ? item.name2 : item.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type='invalid'>{formik.errors.locationId}</Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Vacancy')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='headcount'
                  onChange={formik.handleChange}
                  value={formik.values.headcount}
                  isInvalid={!!formik.errors.headcount}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.headcount}</Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-12'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Note')}</label>
                <Form.Control
                  className='form-control'
                  as='textarea'
                  rows={3}
                  name='comments'
                  onChange={formik.handleChange}
                  value={formik.values.comments || ' '}
                  isInvalid={!!formik.errors.comments}
                />

                <div></div>
              </div>
            </div>
          </div>

          <div className='text-center'>
            <div className='d-flex justify-content-between gap-2'>
              {HasPermission('EditHrPerPosition') && (
                <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100'>
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fas fa-save fa-lg fa-fw me-2'></i>
                  )}
                  {t('Save')}
                </button>
              )}
              <button
                type='button'
                className='btn btn-lg  btn-default mb-1 w-100'
                data-bs-dismiss='modal'
                id='closeModalJob'
              >
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
}

export default EditPosition;
